import React from "react";
import { Routes, Route, Link, useParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Bento from "./pages/tools/Bento";

import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Dashboard from "./pages/app/Dashboard";
import Agencies from "./pages/app/Agencies";
import Companies from "./pages/app/Companies";
import Video from "./pages/app/Video";
import EntityPage from "./pages/app/EntityPage";
import Submit from "./pages/app/Submit";
import Settings from "./pages/app/Settings";
import Boards from "./pages/app/Boards";
import Board from "./pages/app/Board";

import CMS from "./pages/admin/CMS";
import VideoEditor from "./pages/admin/VideoEditor";
import QuickAdd from "./pages/admin/QuickAdd";
import AdminStudioEdit from "./pages/admin/AdminStudioEdit";
import AdminBrandEdit from "./pages/admin/AdminBrandEdit";

import ProtectedRoute from "./utils/ProtectedRoute";
import { AdminRoute } from "./utils/AdminRoute";

function NotFound() {
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col items-center justify-center gap-3 px-8">
      <h1 className="text-4xl font-bold">Page not found</h1>
      <Link to="/" className="underline">
        Back to Discover
      </Link>
    </div>
  );
}

// A fresh editor per video: no form state leaks from one video to another.
function VideoEditorRoute() {
  const { id } = useParams();
  return <VideoEditor key={id ?? "new"} />;
}

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/bento" element={<Bento />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        <Route path="/" element={<Dashboard />} />
        <Route path="/studios" element={<Agencies />} />
        <Route path="/brands" element={<Companies />} />
        <Route path="/video/:id" element={<Video />} />
        <Route path="/brand/:id" element={<EntityPage kind="companies" />} />
        <Route path="/studio/:id" element={<EntityPage kind="agencies" />} />
        <Route path="/submit" element={<Submit />} />

        <Route path="/boards" element={<ProtectedRoute><Boards /></ProtectedRoute>} />
        <Route path="/board/:id" element={<ProtectedRoute><Board /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

        <Route path="/admin" element={<AdminRoute><CMS /></AdminRoute>} />
        <Route path="/admin/quick-add" element={<AdminRoute><QuickAdd /></AdminRoute>} />
        <Route path="/admin/video/new" element={<AdminRoute><VideoEditorRoute /></AdminRoute>} />
        <Route path="/admin/video/:id" element={<AdminRoute><VideoEditorRoute /></AdminRoute>} />
        <Route path="/admin/brand/:id" element={<AdminRoute><AdminBrandEdit /></AdminRoute>} />
        <Route path="/admin/studio/:id" element={<AdminRoute><AdminStudioEdit /></AdminRoute>} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
